import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '../../contexts/AuthContext';
import { isFounderAdmin } from '../../utils/adminAccess';

/**
 * Discreet staff/admin entry — does not expose data; route guards enforce access.
 */
export function StaffFooterLink({ className, variant = 'dark' }) {
  const { user } = useAuth();
  const founder = isFounderAdmin(user);
  const to = user ? '/admin/insights' : '/login';
  const label = founder ? 'Admin' : 'Staff sign-in';

  const tone =
    variant === 'light'
      ? 'text-muted-foreground/70 hover:text-muted-foreground'
      : 'text-white/35 hover:text-white/55';

  return (
    <Link
      to={to}
      className={cn(
        'inline-flex items-center gap-1 text-[11px] tracking-wide transition-colors',
        tone,
        className,
      )}
      data-testid="staff-footer-link"
    >
      <Lock className="h-3 w-3 shrink-0 opacity-80" strokeWidth={1.75} aria-hidden />
      <span>{label}</span>
    </Link>
  );
}

export default StaffFooterLink;
